import { useModal } from '@hrms/common/contexts/modal';
import { useToast } from '@hrms/common/contexts/toast';
import { AllowedSitesInterface } from '@hrms/common/service/access-roles/types';
import { RoleConfigStore } from '@hrms/common/store';
import { Autocomplete, CheckBox, TextField } from '@zeptonow/zui';
import React, { useMemo } from 'react';

const UserPreferenceModalContent: React.FC = () => {
  const { setModalData, modalData } = useModal();
  const { openToast } = useToast();

  const roleConfigAllowedSites = RoleConfigStore(
    (state) => state.roleConfigAllowedSites,
  );

  const selectedTenant = modalData?.selectedTenant;
  const selectedSite = modalData?.selectedSite;
  const checked = modalData?.checked;

  const storeOptions = useMemo(
    () =>
      roleConfigAllowedSites?.find((value) => value?.id === selectedTenant?.id)
        ?.sites,
    [roleConfigAllowedSites, selectedTenant?.id],
  );

  const handleTenantChange = (
    _: React.SyntheticEvent<Element, Event>,
    value: AllowedSitesInterface | null,
  ) => {
    if (!value) return;

    const organization = roleConfigAllowedSites?.find(
      (location) => location?.id === value.id,
    );
    if (!organization) return;
    setModalData((data: Record<string, any>) => ({
      ...data,
      selectedTenant: {
        id: organization.id,
        label: organization.label,
      },
      selectedSite: null,
    }));
  };

  const handleSiteChange = (
    _: React.SyntheticEvent<Element, Event>,
    value: Record<string, string> | null,
  ) => {
    if (!value) {
      console.error('Selected site not found', value);
      return;
    }
    const selectedSite = storeOptions?.find(
      (site: any) => site.id === value?.id,
    );
    if (selectedSite) {
      const locationObj = {
        id: selectedSite.id,
        label: selectedSite.label,
      };
      setModalData((data: Record<string, any>) => ({
        ...data,
        selectedSite: locationObj,
      }));
    }
  };

  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setModalData((data: Record<string, any>) => ({
      ...data,
      checked: event.target.checked,
    }));
  };

  return (
    <>
      <Autocomplete
        value={selectedTenant}
        options={roleConfigAllowedSites ?? []}
        onChange={handleTenantChange}
        className="mb-4"
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Tenant"
            placeholder="Select Tenant"
          />
        )}
      />
      <Autocomplete
        value={selectedSite}
        options={storeOptions ?? []}
        onChange={handleSiteChange}
        className="mb-4"
        disabled={!storeOptions?.length}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Site"
            placeholder="Select Site"
          />
        )}
      />
      <CheckBox
        label="Remember my preference next time"
        size="small"
        checked={checked}
        inputProps={{ 'aria-label': 'controlled' }}
        className="!text-sm !p-2.5"
        onChange={handleCheckBox}
      />
    </>
  );
};

export default UserPreferenceModalContent;
